import React from 'react';
import { Badge } from '../../components/ui/badge';

// Confidence grade → the Badge status variant that colours it.
export const GRADE_STYLES = {
  high: { variant: 'success', label: 'High confidence' },
  good: { variant: 'success', label: 'Good confidence' },
  medium: { variant: 'warning', label: 'Medium confidence' },
  low: { variant: 'destructive', label: 'Low confidence' },
};

export const GradeBadge = ({ grade }) => {
  const style = GRADE_STYLES[grade] || GRADE_STYLES.medium;
  return <Badge variant={style.variant}>{style.label}</Badge>;
};

// Readable name for a column ("mrr_eur_day180" → "mrr eur day180").
export const readable = (col) => (col ? String(col).replace(/_/g, ' ') : '');
